// removed by extract-text-webpack-plugin
module.exports = {"title":"Section__title___3xTSF","subtitle":"Section__subtitle___2mJDI","divider":"Section__divider___C4H41","dividerLine":"Section__dividerLine___D6Kww"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/candidate/signUpMarketing2/components/Section.scss
// module id = 1799
// module chunks = 0